/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css";
import { useTranslation } from "react-i18next";

export default function Footer(): JSX.Element {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6} className="text-center text-sm-end">
            <p>
              {t("Copyright")} 2025 <a href="https://paion-data.com">paion-data.com</a>. {t("All Rights Reserved")}
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
